export default __webpack_public_path__ + "static/title-gallery-zh-Hant-cdcf0a2b31136f6271962304be94766b.png";